export const MAX_FILES_AMOUNT = 50;
export const MAX_FILE_SIZE = 5000000; //5MB
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE/1000000;
export const MAX_UPLOADS_PREVIEW = 15;
export const EMPTY_FILE_SIZE = 0;

export const PHONE_NUMBER_REGEX = /^\(\d{3}\)\d{3}-\d{4}$/;

export const MOBILE_APP_LIVE = true;
